import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import type { C4Connection } from '../lib/connections';

export interface C4ConnectionsDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  connections: C4Connection[];
}

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  empty: {
    color: theme.palette.textSubtle,
  },
}));

export function C4ConnectionsDialog({
  open,
  onClose,
  title,
  connections,
}: C4ConnectionsDialogProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="c4-connections-dialog-title"
    >
      <DialogTitle disableTypography id="c4-connections-dialog-title">
        <div className={classes.title}>
          <Typography variant="h6">Pontos de comunicação — {title}</Typography>
          <IconButton size="small" onClick={onClose} aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        {connections.length === 0 ? (
          <Typography className={classes.empty}>
            Nenhum ponto de comunicação declarado nesta aresta.
          </Typography>
        ) : (
          <Table size="small" data-testid="c4-connections-table">
            <TableHead>
              <TableRow>
                <TableCell>Ponto no código</TableCell>
                <TableCell>Protocolo</TableCell>
                <TableCell>Descrição</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {connections.map((connection, index) => (
                <TableRow key={`${connection.via ?? ''}-${index}`}>
                  <TableCell>{connection.via ?? '—'}</TableCell>
                  <TableCell>{connection.technology ?? '—'}</TableCell>
                  <TableCell>{connection.description ?? '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}
